import { FC } from 'react';
import { Center, VStack } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import SunshineCard from 'components/_core/SunshineCard';
import {
  CatalogItem,
  CatalogItemsPageInfo,
} from 'features/Work/hooks/useCatalogItemsQuery';

import EmptyView from './components/EmptyView';
import locales from './locales';

interface ListProps {
  catalogItems: CatalogItem[];
  pageInfo: CatalogItemsPageInfo | undefined;
  onClearSearch: () => void;
  onFetchMore: () => void;
  onSelectItems: (catalogItems: string[]) => void;
  selectedItems: string[];
  isFetchingMore?: boolean;
}

const List: FC<ListProps> = ({
  catalogItems,
  isFetchingMore,
  onClearSearch,
  onFetchMore,
  onSelectItems,
  pageInfo,
  selectedItems,
}) => {
  if (catalogItems.length === 0) {
    return (
      <EmptyView
        isSearchResult={Boolean(pageInfo?.totalCountWithoutFilters)}
        onClearSearch={onClearSearch}
      />
    );
  }

  return (
    <VStack align="stretch" overflowY="auto" paddingBottom="space-32">
      <SunshineCard.CheckboxGroup
        onChange={onSelectItems}
        value={selectedItems}
      >
        <SunshineCard.Group>
          {catalogItems.map((catalogItem) => (
            <SunshineCard
              key={catalogItem.invoiceCatalogItemId}
              value={catalogItem.invoiceCatalogItemId}
              variant="checkbox"
            >
              <SunshineCard.Content>
                <SunshineCard.Title overflowWrap="anywhere">
                  {catalogItem.title}
                </SunshineCard.Title>

                {catalogItem.subtitle ? (
                  <SunshineCard.Text overflowWrap="anywhere">
                    {catalogItem.subtitle}
                  </SunshineCard.Text>
                ) : null}
              </SunshineCard.Content>
            </SunshineCard>
          ))}
        </SunshineCard.Group>
      </SunshineCard.CheckboxGroup>

      {pageInfo?.hasNextPage ? (
        <Center paddingTop="space-32">
          <Button
            icon="arrow-down"
            isLoading={isFetchingMore}
            onClick={onFetchMore}
            variant="secondary"
          >
            {locales.seeMore}
          </Button>
        </Center>
      ) : null}
    </VStack>
  );
};

export default List;
